import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "accordion-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-partListHeading"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-partList",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-partList"
  }, " PART LIST ")
], -1)
const _hoisted_3 = {
  id: "panelsStayOpen-partList",
  class: "accordion-collapse collapse",
  "aria-labelledby": "panelsStayOpen-partListHeading"
}
const _hoisted_4 = { class: "accordion-body panel-item-height" }
const _hoisted_5 = {
  class: "p-2",
  style: {"border-top":"grey 1px solid"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PartListButtonVue = _resolveComponent("PartListButtonVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentStore.layers, (layer, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "d-flex p-2",
            style: _normalizeStyle(`border-top:${layer[1].color} 1px solid`)
          }, [
            _createElementVNode("div", {
              class: "me-3 p-1",
              style: _normalizeStyle(`color:${layer[1].color}`)
            }, _toDisplayString(layer[1].label), 5),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer[1].contentIds.filter(
                (eid) => _ctx.contentStore.getElement(eid).display
              ), (id, elmIdx) => {
                return (_openBlock(), _createBlock(_component_PartListButtonVue, {
                  key: elmIdx,
                  id: id
                }, null, 8, ["id"]))
              }), 128))
            ])
          ], 4))
        }), 128)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentStore.levelConnectionIds.filter(
                (eid) => _ctx.contentStore.getElement(eid).display
              ), (id, elmIdx) => {
              return (_openBlock(), _createBlock(_component_PartListButtonVue, {
                key: elmIdx,
                id: id
              }, null, 8, ["id"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}